import AnimSection from "../AnimSection/AnimSection";
import "./StatsBand.css";

export default function StatsBandTemplate({ stats }) {
  return (
    <section className="stats-band">
      <div className="stats-band__inner">
        <div className="stats-band__grid">
          {stats.map((stat, i) => (
            <AnimSection key={i} delay={i * 100}>
              <div className="stats-band__card">
                <span className="stats-band__value">{stat.value}</span>
                <span className="stats-band__label">{stat.label}</span>
              </div>
            </AnimSection>
          ))}
        </div>
      </div>
    </section>
  );
}
